var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-geo-json',{attrs:{"geojson":_vm.geojson,"options":{ style: _vm.styleFunction }}})
}
var staticRenderFns = []

export { render, staticRenderFns }